import { useState } from 'react';
import { UserAvatarTooltip } from '../../components/UserAvatar/UserAvatarTooltip';
import { UserAvatar } from '../../components/UserAvatar/UserAvatar';
import { useUserData } from '../../context';
import { PrimaryMenuItemDropdownMenu } from '../PrimaryMenuItemDropdownMenu/PrimaryMenuItemDropdownMenu';
import { UserDropdownMenuItems } from './UserDropdownMenuItems';

export const UserDropdownMenu = () => {
  const { userData: user } = useUserData();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <PrimaryMenuItemDropdownMenu
      size={undefined}
      onOpenedChange={setMenuOpen}
      items={<UserDropdownMenuItems />}
      analyticsMessage="user menu"
      tooltipTitle={!menuOpen && <UserAvatarTooltip userInfo={user?.userInfo} />}
      minWidth="md"
      maxWidth="md"
      dataTestSpecifier="user-avatar-menu"
    >
      <UserAvatar userInfo={user?.userInfo} />
    </PrimaryMenuItemDropdownMenu>
  );
};
